import { make } from 'vuex-pathify'
import repository from '../../apis/repository'

const state = {
	totalItems: 0,
	items: [],
	options: {},
	search: '',
	item: {},
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {

	async datatable({ commit }) {
		const { options, search } = state
		const { data } = await repository.qrUpload.datatable({ ...options, search })
		commit('SET_ITEMS', data.data)
		commit('SET_TOTAL_ITEMS', data.total)

		return data.data
	},
	store(context, payload) {
		return repository.qrUpload.store(payload)
	},
	destroy(context, id) {
		return repository.qrUpload.destroy(id)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
